// helpers
import { getRootOffset } from '../../../assets/js/helpers';

export default class GalleryParts {

	static selector = 'gallery-parts';

	// class variables

	config = {
		isLooping: false
	};

	el = {};

	flags = {};

	states = {
		index: 0,
		total: 0
	};

	// constructor

	constructor(container) {
		this.el = {
			container,
			controls: container.querySelector(`.${this.constructor.selector}__meta-controls`),
			controlsNext: container.querySelector(`.${this.constructor.selector}__meta-control--right`),
			controlsPrev: container.querySelector(`.${this.constructor.selector}__meta-control--left`),
			metaIndex: container.querySelector(`.${this.constructor.selector}__meta-progress-index`),
			partsWrapper: container.querySelector(`.${this.constructor.selector}__parts-wrapper`),

			// multiple

			parts: container.querySelectorAll(`.${this.constructor.selector}__part`)
		};

		this.states.total = this.el.parts.length;

		this.initialize();
	}

	// initialize

	initialize() {
		this.#addEventListeners();
		this.checkIndex(this.states.index);
	}

	// add / remove event listeners

	#addEventListeners = () => {
		this.el.controlsNext.addEventListener('click', this.#onNextClick);
		this.el.controlsPrev.addEventListener('click', this.#onPrevClick);
	}

	#removeEventListeners = () => {
		this.el.controlsNext.removeEventListener('click', this.#onNextClick);
		this.el.controlsPrev.removeEventListener('click', this.#onPrevClick);

	}

	// listener methods

	#onNextClick = () => {
		this.changeIndex(this.states.index + 1);
	}

	#onPrevClick = () => {
		this.changeIndex(this.states.index - 1);
	}

	//

	changeIndex(index) {
		const curIndex = this.checkIndex(index);

		if (curIndex !== this.states.index) {
			const $curPart = this.el.parts[curIndex];
			this.states.index = curIndex;
			this.el.partsWrapper.scroll({
				top: 0,
				left: getRootOffset($curPart).left,
				behavior: 'smooth'
			});
		}
	}

	checkIndex(index) {
		let curIndex = index;

		if (this.config.isLooping) {
			if (index < 0) { curIndex = this.states.total - 1; }
			if (index >= this.states.total) { curIndex = 0; }
		} else {

			if (index <= 0) {
				curIndex = 0;
				this.el.controlsPrev.classList.add('is-disabled');
			} else {
				this.el.controlsPrev.classList.remove('is-disabled');
			}

			if (index >= this.states.total - 1) {
				curIndex = this.states.total - 1;
				this.el.controlsNext.classList.add('is-disabled');
			} else {
				this.el.controlsNext.classList.remove('is-disabled');
			}
		}

		this.el.metaIndex.innerHTML = (curIndex > 9) ? curIndex + 1 : `0${curIndex + 1}`;

		return curIndex;
	}

	// destroy

	destroy() {
		this.#removeEventListeners();
	}

}
